import React, { Component, createRef } from "react";
import Modal from "react-bootstrap/Modal";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import sweetAlert, {
    sweetStatusAlert,
} from "../../../../../components/common/SweetAlert.js";
import { Form } from "react-bootstrap";
import ListItem from "@mui/material/ListItem";
import Button from "@mui/material/Button";
import { StudentService } from "../../../../../service/manage/registration/reg_b.service.js";
import { GenderService } from "../../../../../service/settings/manage/gender.service.js";
import { StatusService } from "../../../../../service/settings/manage/status.service.js";
import { DesignationService } from "../../../../../service/settings/manage/designation.service.js";
import { NonAcademicService } from "../../../../../service/manage/registration/reg_b_staff.service.js";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AHSlogo from "../../../../../assets/images/AEHS-Logo.png";
import SimpleReactValidator from "simple-react-validator";
import RegBStaffDocSubmission from "./RegBStaffDocSubmission.js";
import config from "../../../../../helper/config.js";
import { customerConstants } from "../../../../../helper/constants.js";
import { AzureStorageManage } from "../../../../../helper/azureStorageManage.js";
import {
    aehsDocSubmisBlobName,
    regBStaffDocUploadTypes
} from "../../../../../helper/namespace.js";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import './courselist.css';

const lightTheme = createTheme({ palette: { mode: "light" } });

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    textAlign: "center",
    color: theme.palette.text.secondary,
    lineHeight: "40px",
    padding: theme.spacing(2), // Add padding
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(3),
}));

const getCustomerFeatureFlag = () => {
    return config.customerConfigs.featureFlag;
};
let cancelClass, confirmClass;
const customer = getCustomerFeatureFlag();
switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
        cancelClass = "btn-default";
        confirmClass = "btn-primary";
        break;
    case customerConstants.EXO_CUSTOMER2:
    // cancelClass = "cmc-btn-default"
    // confirmClass = "cmc-btn-primary"
    default:
        cancelClass = "btn-default";
        confirmClass = "btn-primary";
        break;
}


class BlockLetterInput extends Component {
    constructor(props) {
        super(props);
        this.textRefs = Array.from({ length: this.props.values.length }, () =>
            createRef()
        );
    }

    handleChange = (e, index) => {
        const { values, setValues } = this.props;
        const newValues = [...values];
        newValues[index] = e.target.value.toUpperCase().slice(-1);
        setValues(newValues);

        if (index < this.textRefs.length - 1 && newValues[index]) {
            this.textRefs[index + 1].current.focus();
        }
    };

    handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !this.props.values[index]) {
            const { values, setValues } = this.props;
            const newValues = [...values];
            newValues[index - 1] = "";
            setValues(newValues);
            this.textRefs[index - 1].current.focus();
        }
    };

    render() {
        const { values, label, refIndex, validationMessage, disbaleAllApplicatInputs } = this.props;
        const lines = [];
        for (let i = 0; i < values.length; i += 20) {
            lines.push(values.slice(i, i + 20));
        }

        return (
            <Box sx={{ p: 2 }}>
                <Grid container alignItems="center" spacing={0.7}>
                    <Grid item xs={2}>
                        <Item
                            elevation={0}
                            sx={{
                                fontWeight: "bold",
                                height: "100%",
                                backgroundColor: "#E0E8ED",
                            }}
                        >
                            {label}
                        </Item>
                    </Grid>
                    <Grid item xs={10}>
                        {lines.map((line, lineIndex) => (
                            <Box
                                key={lineIndex}
                                sx={{
                                    borderRadius: 0,
                                    display: "flex",
                                    gap: 0.2,
                                    marginBottom: 0.5,
                                    height: "100%",
                                    flexDirection: "column", // Adjusted to have validation message below the blocks
                                }}
                            >
                                <Box sx={{ display: "flex", gap: 0.2 }}>
                                    {line.map((value, index) => (
                                        <TextField
                                            key={index + lineIndex * 20}
                                            value={value}
                                            onChange={(e) =>
                                                this.handleChange(e, index + lineIndex * 20)
                                            }
                                            onKeyDown={(e) =>
                                                this.handleKeyDown(e, index + lineIndex * 20)
                                            }
                                            inputRef={
                                                index + lineIndex * 20 === refIndex
                                                    ? this.props.forwardedRef
                                                    : this.textRefs[index + lineIndex * 20]
                                            }
                                            inputProps={{
                                                maxLength: 1,
                                                style: {
                                                    borderRadius: 0,
                                                    textTransform: "uppercase",
                                                    width: "4.8ch",
                                                    height: "5.5ch",
                                                    textAlign: "center",
                                                    backgroundColor: "#E0E8ED",
                                                    padding: "0px",
                                                },
                                            }}
                                            sx={{
                                                borderRadius: 0,
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: 0, // Remove rounded corners
                                                },
                                            }}
                                            disabled={disbaleAllApplicatInputs}
                                        />
                                    ))}
                                </Box>
                                {lineIndex === lines.length - 1 && (
                                    <Typography
                                        variant="body2"
                                        sx={{ color: "red", textAlign: "left", mt: 0.5 }}
                                    >
                                        {validationMessage}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                    </Grid>
                </Grid>
            </Box>
        );
    }
}
export default class RegBAddStaffModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isModified: false,
            showInsertModal: false,
            first_name: "",
            last_name: "",
            user_code: "No",
            name_as_nic: "",
            gender: "",
            dob: "",
            nationality: "",
            designations: [],
            statuses: [],
            genders: [],
            nic: "",
            mobile: "",
            email: "",
            home: "",
            gender_id: "",
            designation_id: "",
            status_id: "",
            office: "",
            address_for_correspondence: "",
            permanent_address: "",
            work_experience: "",
            min_entry_qualification: "",
            name_designation: "",
            status: "",
            overseas_nic_passport: 0,
            overseas_educational_doc: 0,
            overseas_color_photo: 0,
            overseas_work_experience_doc: 0,
            selectedMedium: '',
            selectedShedule: '',


            lg_user_id: sessionStorage.getItem("manage_user_id"),
            lg_user_table_id: sessionStorage.getItem("table_log_id"),

            uploadFiles: {
                selectedFiles: [],
                selectedFileCertificates: [],
                selectedFileNIC: [],
                selectedFilePoliceReports: [],
                selectedFileOther: [],
            },
            disbaleAllApplicatInputs: true,
            disableApplicantAcknowledge: true,
            disableApprove: true,

            formIsValid: false,
            user_approval: 0,
            info_approval: 0,
            officeSectionAvailability: false,
            hasFullPrivilege: this.checkFullPrivilege(),
        };

        this.createValidationsInstance();
        this.formInitialState = {
            isModified: false,
            isLoading: false,
            first_name: "",
            last_name: "",
            user_code: "",
            name_as_nic: "",
            gender: "",
            dob: new Date(),
            nationality: "",
            nic: "",
            mobile: "",
            email: "",
            home: "",
            office: "",
            address_for_correspondence: "",
            permanent_address: "",

            english_ability: 0,
            min_entry_qualification: "",
            name_designation: "",
            status: 0,
            overseas_nic_passport: 0,
            overseas_educational_doc: 0,
            overseas_color_photo: 0,
            overseas_work_experience_doc: 0,
            selectedMedium: '',
            selectedShedule: '',
            uploadFiles: {
                selectedFiles: [],
                selectedFileCertificates: [],
                selectedFileNIC: [],
                selectedFilePoliceReports: [],
                selectedFileOther: [],
            },

            formIsValid: false,
            enrollments: this.props?.enrollments || [],
            checked_enrollments: [],
        };
    }
    getGenderDropdownValues = () => {
        GenderService.getAllGenders().then((res) => {
            this.setState({ genders: res.data });
        });
    };

    getDesignationDropdownValues = () => {
        DesignationService.getAllDesignations().then((response) => {
            if (response.success) {
                this.setState({ designations: response.data });
            }
        });
    };

    getUserStatusDropdownValues = () => {
        StatusService.getAllStatusesForDropdown().then((response) => {
            if (response.success) {
                this.setState({ statuses: response.data });
            }
        });
    };

    createValidationsInstance() {
        this.validator = new SimpleReactValidator({
            validators: {
                address: {
                    message: "The :attribute must be a valid address",
                    rule: (val, params, validator) => {
                        return (
                            validator.helpers.testRegex(val, /^[a-zA-Z-/:0-9,\s]+$/i) &&
                            params.indexOf(val) === -1
                        );
                    },
                    messageReplace: (message, params) =>
                        message.replace(":values", this.helpers.toSentence(params)), // optional
                },
                dateBefore: {
                    message: "The :attribute must be before current date",
                    rule: (val, params, validator) => {
                        const selectedDate = new Date(val);
                        const currentDate = new Date();
                        return selectedDate < currentDate;
                    },
                    messageReplace: (message, params) =>
                        message.replace(":values", this.helpers.toSentence(params)), // optional
                    required: true,
                },
                phone_number: {
                    message: "The :attribute must be a valid phone number",
                    rule: (val, params, validator) => {
                        const isTenDigitsStartingWithZero =
                            val.length === 10 && val.startsWith("0");
                        const isNineDigits = val.length === 9 && !val.startsWith("0");
                        return isTenDigitsStartingWithZero || isNineDigits;
                    },
                    messageReplace: (message, params) =>
                        message.replace(":values", this.helpers.toSentence(params)), // optional
                    required: true,
                },
            },
        });
        this.updateValidator = new SimpleReactValidator();
    }

    componentDidMount() {
        this.getDesignationDropdownValues();
        this.getGenderDropdownValues();
        this.getUserStatusDropdownValues();
        let privilege_edit = !!this.props.state.privilege_edit;
        let privilege_add = !!this.props.state.privilege_add;
        let privilege_delete = !!this.props.state.privilege_delete;
        this.setState({
            disbaleAllApplicatInputs: (!privilege_edit && !privilege_add),
            disableApplicantAcknowledge: !privilege_edit || !this.validator.allValid(),
            disableApprove: !privilege_delete,
            officeSectionAvailability: privilege_delete || privilege_add,
        })

    }

    getNewStudentId = async () => {
        const response = await StudentService.getRegStudentId();

        if (response.success) {
            const { new_id } = response.data;
            if (new_id) {
                this.setState({ user_code: new_id });
            }
        } else {
            this.setState({ user_code: "Student Id Error" });
        }
    };

    toggleAddStudentModal = () => {
        this.setState(
            (prevState) => ({
                showInsertModal: !prevState.showInsertModal,
                first_name: "",
                last_name: "",
                nic: "",
                dob: "",
                email: "",
                phone_number: "",
                gender_id: "",
                designation_id: "",
                status_id: "",
                created_on: "",
                created_by: "",
                studentAddresses: [],
                grade: null,
                school: "",
            }),
            () => {
                if (this.state.showInsertModal) {
                }
            }
        );
    };

    handleSweetAlert = (toggleFunction, modalVisibility) => {
        if (this.state.isModified) {
            sweetAlert().then((response) => {
                this.setState(this.formInitialState);
                this.setState(() => ({
                    [modalVisibility]: response,
                    isModified: false,
                }));
                this.toggleAddStudentModal();
                toggleFunction();
            });
        } else {
            this.setState(this.formInitialState);
            this.toggleAddStudentModal();
            toggleFunction();
        }
    };

    updateFormValidity = () => {
        const formIsValid = this.validator.allValid();
        if (formIsValid) {
            this.setState({
                disableApplicantAcknowledge: !this.props.state.privilege_edit || !formIsValid
            });
        }
        this.setState({ formIsValid });
    };

    handleChange = (event) => {
        const { name, type, checked, value } = event.target;
        const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
        this.setState({ [name]: newValue, isModified: true }, () => {
            this.updateFormValidity()
        });
    };

    handleMedium = (event) => {
        this.setState({ selectedMedium: event.target.value }, () => {
            this.updateFormValidity()
        });
    };

    handleShedule = (event) => {
        this.setState({ selectedShedule: event.target.value }, () => {
            this.updateFormValidity()
        });
    };

    handleBlockInputChangeFullName = (newValues) => {
        this.setState({ full_name: newValues }, () => {
            this.updateFormValidity()
        });
        const fullNameString = this.convertArrayToString(newValues);
    };

    handleBlockInputChangeFirstName = (newValues) => {
        this.setState({ first_name: newValues }, () => {
            this.updateFormValidity()
        });
        const firstNameString = this.convertArrayToString(newValues);
    };

    handleBlockInputChangeLastName = (newValues) => {
        this.setState({ last_name: newValues }, () => {
            this.updateFormValidity()
        });
        const lastNameString = this.convertArrayToString(newValues);
    };

    convertArrayToString = (arr) => {
        if (Array.isArray(arr)) {
            return arr.join("").trim();
        }
        return "";
    };

    handleUploadFiles = (uploadFiles) => {
        this.setState(
            {
                uploadFiles: uploadFiles,
            },
            () => { }
        );
    };

    // Helper function to read file as text
    readFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                resolve(event.target.result);
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsArrayBuffer(file);
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
        } else {
            this.setState({ isLoading: true });
            try {
                const {
                    first_name,
                    last_name,
                    gender,
                    nic,
                    gender_id,
                    designation_id,
                    mobile,
                    email,
                    address,
                    designation,
                    status_id,
                    note,
                } = this.state;

                const newRegStudent = {
                    node_mid: !!this.props.state && !!this.props.state.mid
                        ? this.props.state.mid
                        : 100,
                    first_name: first_name,
                    last_name: last_name,
                    nic: nic,
                    gender_id: gender_id,
                    mobile: mobile,
                    email: email,
                    address: address,
                    designation_id: designation_id,
                    status: status_id,
                    note: note,
                };
                const staffResponse = await NonAcademicService.create_reg_non_academic(
                    JSON.stringify(newRegStudent)
                );
                if (staffResponse.success) {
                    let userData = {
                        user_code: staffResponse.data.user_code,
                        user_id: staffResponse.data.user_id,
                        user_table_id: staffResponse.data.user_table_id,
                    };
                    this.onFileUpload(userData);
                    this.setState({ isLoading: false });
                    sweetStatusAlert(
                        "Success!",
                        "New staff member added successfully!",
                        "success"
                    );
                    this.props.toggleAddStudentModal();
                    this.setState(this.formInitialState);
                } else {
                    sweetStatusAlert("Failed!", staffResponse.message, "error");
                    this.setState({ isLoading: false });
                }
            } catch (e) {
                this.setState({ isLoading: false });
                sweetStatusAlert("Failed!", "Failed to create new staff member", "error");
            }

        }
    };

    checkFullPrivilege = () => {
        const { privilege_edit, privilege_add, privilege_delete } = this.props.state;
        return privilege_edit && privilege_add && privilege_delete;
    };

    handleCheckboxChange = (mid) => {
        if (!this.state.hasFullPrivilege) return;

        this.setState((prevState) => {
            const updatedEnrollments = prevState.enrollments.map((course) =>
                course.mid === mid ? { ...course, checked: !course.checked } : course
            );
            const updatedCheckedEnrollments = updatedEnrollments.filter(
                (course) => course.checked
            );

            return {
                enrollments: updatedEnrollments,
                checked_enrollments: updatedCheckedEnrollments,
            };
        });
    };


    componentDidUpdate(prevProps) {
        if (prevProps.enrollments !== this.props.enrollments) {
            this.setState({ enrollments: this.props.enrollments });
        }
    }

    handleBlobsDetail = async (
        labelName,
        user_code
    ) => {
        const { uploadFiles } = this.state;

        const form_list = this.props.state.form_list_id;
        let blobIds = [];
        if (!!uploadFiles.length) {
            const typeBlobDetails = await Promise.all(
                uploadFiles.map(async (file, index) => {
                    const name_ = file[0]?.name;
                    const blobId = aehsDocSubmisBlobName(
                        name_,
                        form_list,
                        labelName,
                        index,
                        user_code
                    );
                    const readData = await this.readFile(file[0]);
                    blobIds.push(blobId);
                    return {
                        blobData: readData,
                        blobName: blobId,
                    };
                })
            );
            return {
                typeBlobDetails: typeBlobDetails,
                typeIds: blobIds,
            };
        } else {
            return {
                typeBlobDetails: [],
                typeIds: blobIds,
            };
        }
    };

    onFileUpload = async ({ user_code, user_id, user_table_id }) => {
        const { lg_user_id, lg_user_table_id } = this.state;
        const form_list = this.props.state.form_list_id;
        let container_id = `${customer}_form${form_list}`
            .toLowerCase()
            .replace(/[^a-z0-9-]/g, "-")
            .replace(/^-+|-+$/g, "");
        const handleBlobsDetailPhoto = await this.handleBlobsDetail(
            "staff",
            user_code
        );
        const blobDetailsAllType = await Promise.all([
            ...handleBlobsDetailPhoto.typeBlobDetails,
        ]);
        try {
            await AzureStorageManage.multiUploadBlob(
                container_id,
                blobDetailsAllType
            );

            const obj = {
                user_id: user_id,
                user_table_id: user_table_id,
                create_user_id: lg_user_id,
                create_user_table_id: lg_user_table_id,
                container_id: container_id,
                blob_details: [
                    {
                        upload_type_id: regBStaffDocUploadTypes.REG_B_STAFF_UPLOADS.id,
                        blob_ids: handleBlobsDetailPhoto?.typeIds,
                    },
                ],
            };
            await NonAcademicService.addRegUploads(JSON.stringify(obj));
            // sweetStatusAlert(namespace.SUCCESS, `File uploaded successfully!!!`, "success")
        } catch (e) {
        } finally {
        }
    };

    render() {
        const {
            isLoading,
            first_name,
            last_name,
            designation,
            status,
            gender,
            nic,
            mobile,
            email,
            address,
            gender_id,
            designation_id,
            status_id,
            note,
            genders,
            designations,
            statuses,
            disbaleAllApplicatInputs,
        } = this.state;

        const { isAddStaffModalOpen, toggleAddStudentModal } = this.props;
        return (
            <>
                <Modal
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={isAddStaffModalOpen}
                    onHide={() =>
                        this.handleSweetAlert(toggleAddStudentModal, "showInsertModal")
                    }
                >
                    <Modal.Header closeButton>
                        <Modal.Title centered={true}>
                            Asian Elite Hotel School
                            <img alt="Logo" className="logo" src={AHSlogo} style={{ width: "60px", height: "auto" }} />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Backdrop
                            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={isLoading}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        <Form>
                            <Grid container spacing={5} rowSpacing={5}>
                                {[lightTheme].map((theme, index) => (
                                    <ThemeProvider theme={theme} key={index}>
                                        <Grid item xs={12}>
                                            <Item elevation={8}>
                                                <Grid
                                                    alignItems="center"
                                                    container
                                                    spacing={2}
                                                    sx={{ p: 2 }}
                                                >
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{ fontWeight: "bold" }}
                                                        >
                                                            Non Academic Staff Registration
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Item elevation={8}>
                                                <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                                                </Grid>
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    alignItems="center"
                                                    sx={{ p: 2 }}
                                                >
                                                    <Grid item xs={12}>
                                                        <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                                                            <Grid
                                                                container
                                                                spacing={1}
                                                                alignItems="center"
                                                                sx={{ pl: 5, pr: 5 }}
                                                            >
                                                            <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="first_name"
                                                                            value={first_name}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="First Name"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "first_name",
                                                                                first_name,
                                                                                "required|first_name|max:50",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The first name is required.",
                                                                                        max: "First name must be less than 50 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="last_name"
                                                                            value={last_name}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Last Name"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "last_name",
                                                                                last_name,
                                                                                "required|last_name|max:50",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The last name is required.",
                                                                                        max: "Last name must be less than 50 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="mobile"
                                                                            value={mobile}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Mobile number"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "mobile",
                                                                                mobile,
                                                                                "required|numeric|min:9|max:12",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required:
                                                                                            "The mobile number is required.",
                                                                                        numeric:
                                                                                            "The mobile number must contain only digits.",
                                                                                        min: "The mobile number must be at least 9 digits.",
                                                                                        max: "The mobile number cannot exceed 12 digits.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="email"
                                                                            value={email}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Email"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "email",
                                                                                email,
                                                                                "required|email|max:150",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The email is required.",
                                                                                        max: "Email must be less than 150 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            value={nic}
                                                                            onChange={this.handleChange}
                                                                            name="nic"
                                                                            id="outlined-basic"
                                                                            label="NIC / Passport No"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                            fullWidth
                                                                            sx={{ bgcolor: "#E0E8ED" }} // Consistent background color
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "nic",
                                                                                nic,
                                                                                "required|max:12",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The NIC is required.",
                                                                                        max: "The NIC must be no longer than 12 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="address"
                                                                            value={address}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Address"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "address",
                                                                                address,
                                                                                "required|max:200",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "Address is required.",
                                                                                        max: "Address must be less than 200 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                            </Grid>
                                                        </Item>
                                                        <Row>
                                                            <Col xs={12} md={4} className="pl-0">
                                                                <Form.Group controlId="exampleForm.ControlInput1">
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <Item
                                                                            elevation={0}
                                                                            sx={{
                                                                                lineHeight: "20px",
                                                                                fontWeight: "bold",
                                                                                width: "30%",
                                                                            }}
                                                                        >
                                                                            Gender
                                                                        </Item>
                                                                        <Form.Select
                                                                            aria-label="Default select example"
                                                                            name="gender_id"
                                                                            value={gender_id}
                                                                            onChange={this.handleChange}
                                                                            style={{ backgroundColor: "#E0E8ED", flex: 1, width: "70%" }}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {genders?.map((gender) => (
                                                                                <option key={gender.gender_id} value={gender.gender_id}>
                                                                                    {gender.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </div>
                                                                    {this.validator.message(
                                                                        "gender_id",
                                                                        gender_id,
                                                                        "required",
                                                                        {
                                                                            className: "text-danger",
                                                                            messages: {
                                                                                required: "The gender is required.",
                                                                            },
                                                                        }
                                                                    )}
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs={12} md={4} className="pl-0">
                                                                <Form.Group controlId="exampleForm.ControlInput2">
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <Item
                                                                            elevation={0}
                                                                            sx={{
                                                                                lineHeight: "20px",
                                                                                fontWeight: "bold",
                                                                                width: "30%",
                                                                            }}
                                                                        >
                                                                            Designation
                                                                        </Item>
                                                                        <Form.Select
                                                                            aria-label="Default select example"
                                                                            name="designation_id"
                                                                            value={designation_id}
                                                                            onChange={this.handleChange}
                                                                            style={{ backgroundColor: "#E0E8ED", flex: 1, width: "70%" }}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {designations?.map((designation) => (
                                                                                <option key={designation.designation_id} value={designation.designation_id}>
                                                                                    {designation.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </div>
                                                                    {this.validator.message(
                                                                        "designation",
                                                                        designation_id,
                                                                        "required",
                                                                        {
                                                                            className: "text-danger",
                                                                            messages: {
                                                                                required: "The designation is required.",
                                                                            },
                                                                        }
                                                                    )}
                                                                </Form.Group>
                                                            </Col>

                                                            <Col xs={12} md={4} className="pl-0">
                                                                <Form.Group controlId="exampleForm.ControlInput3">
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <Item
                                                                            className="member_status_item"
                                                                            elevation={0}
                                                                            sx={{
                                                                                lineHeight: "20px",
                                                                                fontWeight: "bold",
                                                                                width: "30%",
                                                                            }}
                                                                        >
                                                                            Status
                                                                        </Item>
                                                                        <Form.Select
                                                                            aria-label="Default select example"
                                                                            name="status_id"
                                                                            value={status_id}
                                                                            onChange={this.handleChange}
                                                                            style={{ backgroundColor: "#E0E8ED", flex: 1, width: "70%" }}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {statuses?.map((status) => (
                                                                                <option key={status.status_id} value={status.status_id}>
                                                                                    {status.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </div>
                                                                    {this.validator.message(
                                                                        "status",
                                                                        status_id,
                                                                        "required",
                                                                        {
                                                                            className: "text-danger",
                                                                            messages: {
                                                                                required: "The status is required.",
                                                                            },
                                                                        }
                                                                    )}
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                                                            <Grid
                                                                container
                                                                spacing={1}
                                                                alignItems="center"
                                                                sx={{ pl: 5, pr: 5 }}
                                                            >
                                                                <Grid item xs={12}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            height: "250px",
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            value={note}
                                                                            onChange={this.handleChange}
                                                                            name="note"
                                                                            multiline
                                                                            rows={11}
                                                                            fullWidth
                                                                            id="outlined-textarea"
                                                                            label="Note"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                    </Item>
                                                                    <div style={{ textAlign: "left" }}>
                                                                    {this.validator.message(
                                                                        "note",
                                                                        note,
                                                                        "max:2000",
                                                                        {
                                                                        className: "text-danger",
                                                                        messages: {
                                                                            max: "Note should not be greater than 2000 characters."
                                                                        },
                                                                        }
                                                                    )}
                                                                        </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={2} sx={{ textAlign: "left" }}>
                                                    <RegBStaffDocSubmission
                                                        disbaleAllApplicatInputs={disbaleAllApplicatInputs}
                                                        uploadFiles={this.state.uploadFiles}
                                                        handleUploadFiles={this.handleUploadFiles}
                                                    />
                                                </Grid>
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    alignItems="center"
                                                    sx={{ p: 2 }}
                                                >
                                                    <Grid item xs={12}>
                                                        <List
                                                            sx={{
                                                                width: "100%",
                                                                maxWidth: 200,
                                                                bgcolor: "background.paper",
                                                            }}
                                                        />
                                                        <ListItem>
                                                        </ListItem>
                                                    </Grid>
                                                </Grid>
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    alignItems="center"
                                                    sx={{ p: 2 }}
                                                >
                                                    <Grid item xs={12}>
                                                        <ListItem>
                                                        </ListItem>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                        <Grid item xs={12}>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Item elevation={0}>
                                                <Button
                                                    variant="contained"
                                                    size="large"
                                                    onClick={this.handleSubmit}
                                                >
                                                    Submit
                                                </Button>
                                            </Item>
                                        </Grid>
                                    </ThemeProvider>
                                ))}
                            </Grid>
                        </Form>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
